type Message = {
	status: 'error' | 'message' | 'completed' | 'cancel' | 'modify'
	data: any
}

export const sendMessage = (message: string | Message) => {
	if (typeof message === 'string') {
		message = { status: 'message', data: message }
	}

	const messenger: any = (window as any).ReactNativeWebView || false
	if (messenger && messenger.postMessage) {
		messenger.postMessage(JSON.stringify(message))
	} else {
		console.log(message)
	}
}
